import * as React from "react";
import { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FormControl from "@mui/material/FormControl";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import EditWordGroupQuery from "./EditWordGroupQuery";
import EditMeaningsQuery from "./EditMeaningsQuery";
import { editWordValidation } from "../../../../../validations/vocabularyFormsValidaton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededData = {
  status: "وضعیت",
  date: "تاریخ",
};
function createData(name, data) {
  return { name, data };
}

export default function EditWord(props) {
  const detectSize600px = useMediaQuery("(min-width:600px)");

  const { handleCloseDialogContent, dataContent, editWordInBack } = props;
  //   console.log("131313", dataContent);
  //   console.log(
  //     "131313",
  //     dataContent.filter((e) => e["data"]["name"] == "toLang")
  //   );
  const catchData = (item) => {
    let data = dataContent.filter((e) => e["data"]["name"] == item);
    if ((item == "fromLang" || item == "toLang") && data.length > 0) {
      let lang = Object.keys(languagesList).filter(
        (langCode) => languagesList[langCode] == data[0]["data"]["data"]
      );
      return lang[0];
    } else if (data.length > 0) return data[0]["data"]["data"];
    else return "";
  };

  const [clearDataForm, setClearDataForm] = useState([]);
  const [saveWordId, setSaveWordId] = useState(catchData("_id"));
  const [fromLang, setFromLang] = useState(catchData("fromLang"));
  const [toLang, setToLang] = useState(catchData("toLang"));
  const [word, setWord] = useState(catchData("word"));
  const [meanings, setMeanings] = useState(catchData("meanings"));
  const [groups, setGroups] = useState(catchData("groups"));

  const initialValues = {
    saveWordId,
    fromLang,
    toLang,
    word,
    meanings,
    groups,
  };

  const handleSetFieldValues = (props, Field, value) => {
    if (!value || value.length == 0) {
      let fieldName = [Field];
      setClearDataForm([...clearDataForm, ...fieldName]);
    } else {
      let deletedFields = clearDataForm;
      let index = deletedFields.indexOf(Field);
      if (index > -1) {
        deletedFields.splice(index, 1);
        setClearDataForm(deletedFields);
      }
    }
    props.setFieldValue(Field, value);
  };

  const filterItems = (obj) => {
    for (const property in obj) {
      if (typeof obj[property] == "boolean") continue;
      if (!obj[property] && clearDataForm.includes(property))
        obj[property] = "llmmt-Deleted";
    }
    return obj;
  };

  const onSubmit = (values, props) => {
    // console.log("clearDataForm", clearDataForm);
    const data = filterItems(values);
    // console.log("asdmir", values);
    editWordInBack(data);
  };

  return (
    <>
      <DialogContent dividers>
        <Box>
          <Formik
            initialValues={initialValues}
            validationSchema={editWordValidation}
            onSubmit={onSubmit}
          >
            {(props) => (
              <Form>
                <TableContainer component={Paper}>
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell
                          sx={{ width: detectSize600px ? "25%" : "50%" }}
                        ></StyledTableCell>
                        <StyledTableCell
                          sx={{ width: detectSize600px ? "75%" : "50%" }}
                        >
                          {" "}
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          {"زبان لغت"}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <FormControl style={{ minWidth: 170 }}>
                            <InputLabel id="demo-simple-select-label">
                              زبان لغت
                            </InputLabel>
                            <Select
                              size="small"
                              label="fromLang"
                              name="fromLang"
                              id="fromLang"
                              value={fromLang}
                              onChange={(e) => {
                                setFromLang(e.target.value);
                                handleSetFieldValues(
                                  props,
                                  "fromLang",
                                  e.target.value
                                );
                              }}
                            >
                              <MenuItem key={0} value={"fa"}>
                                Persian
                              </MenuItem>
                              <MenuItem autoFocus key={1} value="en">
                                English
                              </MenuItem>
                              {Object.keys(languagesList).map(
                                (option, index) => (
                                  <MenuItem key={index + 2} value={option}>
                                    {languagesList[option]}
                                  </MenuItem>
                                )
                              )}
                            </Select>
                            <FormHelperText
                              sx={{ color: "#f96767", textAlign: "center" }}
                            >
                              <ErrorMessage name="fromLang" />
                            </FormHelperText>
                          </FormControl>
                        </StyledTableCell>
                      </StyledTableRow>

                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          {"زبان ترجمه"}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <FormControl style={{ minWidth: 170 }}>
                            <InputLabel id="demo-simple-select-label">
                              زبان ترجمه
                            </InputLabel>
                            <Select
                              size="small"
                              label="toLang"
                              name="toLang"
                              id="toLang"
                              value={toLang}
                              onChange={(e) => {
                                setToLang(e.target.value);
                                handleSetFieldValues(
                                  props,
                                  "toLang",
                                  e.target.value
                                );
                              }}
                            >
                              <MenuItem key={0} value={"fa"}>
                                Persian
                              </MenuItem>
                              <MenuItem autoFocus key={1} value="en">
                                English
                              </MenuItem>
                              {Object.keys(languagesList).map(
                                (option, index) => (
                                  <MenuItem key={index + 2} value={option}>
                                    {languagesList[option]}
                                  </MenuItem>
                                )
                              )}
                            </Select>
                            <FormHelperText
                              sx={{ color: "#f96767", textAlign: "center" }}
                            >
                              <ErrorMessage name="toLang" />
                            </FormHelperText>
                          </FormControl>
                        </StyledTableCell>
                      </StyledTableRow>

                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          {"لغت"}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Field
                            type="text"
                            size="small"
                            as={TextField}
                            name="word"
                            value={word}
                            onChange={(e) => {
                              setWord(e.target.value);
                              handleSetFieldValues(
                                props,
                                "word",
                                e.target.value
                              );
                            }}
                            label="لغت"
                            placeholder="لغت"
                          />
                          <FormHelperText
                            sx={{
                              m: 0,
                              p: 0,
                              color: "#f96767",
                              textAlign: "center",
                            }}
                          >
                            <ErrorMessage name="word" />
                          </FormHelperText>
                        </StyledTableCell>
                      </StyledTableRow>

                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          {"ترجمه ها"}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <EditMeaningsQuery
                            defaultMeinings={meanings}
                            formProps={props}
                            handleMeaningsSelected={(props, data) => {
                              handleSetFieldValues(props, "meanings", data);
                            }}
                          // defaults={groups}
                          // formProps={props}
                          // handleGroupWordSelected={(props, data) => {
                          //   handleSetFieldValues(props, "groups", data);
                          // }}
                          />
                          <FormHelperText
                            sx={{ color: "#f96767", textAlign: "center" }}
                          >
                            <ErrorMessage name="groups" />
                          </FormHelperText>
                        </StyledTableCell>
                      </StyledTableRow>

                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          {"گروه لغات"}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <EditWordGroupQuery
                            defaults={groups}
                            formProps={props}
                            handleGroupWordSelected={(props, data) => {
                              handleSetFieldValues(props, "groups", data);
                            }}
                          />
                          <FormHelperText
                            sx={{ color: "#f96767", textAlign: "center" }}
                          >
                            <ErrorMessage name="groups" />
                          </FormHelperText>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ m: 2 }}
                  color="success"
                >
                  ذخیره
                </Button>
              </Form>
            )}
          </Formik>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          variant="contained"
          onClick={handleCloseDialogContent}
        >
          بستن
        </Button>
      </DialogActions>
    </>
  );
}
const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
